import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

const categoryImages: Record<string, string> = {
  're-xue': 'https://readdy.ai/api/search-image?query=action%20adventure%20anime%20illustration%20of%20a%20young%20warrior%20in%20a%20dynamic%20battle%20stance%20with%20fiery%20energy%2C%20warm%20orange%20and%20vermilion%20palette%2C%20bold%20manga%20art%2C%20clean%20category%20banner%2C%20high%20detail&width=800&height=500&seq=cat-rexue-01&orientation=landscape',
  'xuan-huan': 'https://readdy.ai/api/search-image?query=fantasy%20xuanhuan%20anime%20illustration%20of%20an%20immortal%20swordsman%20among%20misty%20clouds%20and%20mountains%2C%20gold%20and%20teal%20palette%2C%20mystical%20manga%20art%2C%20clean%20category%20banner%2C%20detailed%20linework&width=800&height=500&seq=cat-xuanhuan-02&orientation=landscape',
  'lian-ai': 'https://readdy.ai/api/search-image?query=sweet%20romance%20anime%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%20with%20soft%20pastel%20tones%2C%20pink%20and%20cream%20palette%2C%20tender%20romantic%20manga%20art%2C%20clean%20category%20banner%2C%20charming&width=800&height=500&seq=cat-lianai-03&orientation=landscape',
  'xuan-yi': 'https://readdy.ai/api/search-image?query=mystery%20suspense%20anime%20illustration%20of%20a%20detective%20with%20a%20magnifying%20glass%20in%20a%20dark%20moody%20scene%2C%20deep%20blue%20and%20crimson%20palette%2C%20mysterious%20manga%20art%2C%20clean%20category%20banner%2C%20atmospheric&width=800&height=500&seq=cat-xuanyi-04&orientation=landscape',
  'gao-xiao': 'https://readdy.ai/api/search-image?query=funny%20comedy%20anime%20illustration%20of%20happy%20cartoon%20characters%20laughing%20together%2C%20bright%20cheerful%20yellow%20and%20orange%20palette%2C%20playful%20manga%20art%2C%20clean%20category%20banner%2C%20vibrant%20and%20fun&width=800&height=500&seq=cat-gaoxiao-05&orientation=landscape',
  'ke-huan': 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20anime%20illustration%20of%20a%20mecha%20pilot%20against%20a%20starry%20space%20city%2C%20cyan%20and%20amber%20palette%2C%20epic%20manga%20art%2C%20clean%20category%20banner%2C%20high%20detail&width=800&height=500&seq=cat-kehuan-06&orientation=landscape',
};

function CategorySection() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="category-title">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">分类浏览</span>
          <h2 id="category-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按题材分类找漫画
          </h2>
          <p className="mt-2 text-sm text-foreground-600">热门题材一网打尽，点击进入专属分类</p>
        </div>
        <Link to="/category" className="hidden whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex">
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5">
        {mangaCategories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative flex h-40 items-end overflow-hidden rounded-lg md:h-48"
            title={`${cat.name} 漫画分类`}
          >
            <img
              src={categoryImages[cat.slug]}
              alt={`${cat.name} 漫画分类封面`}
              title={`${cat.name} 漫画分类`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
            <div className="relative p-4 md:p-5">
              <h3 className="text-lg font-bold text-background-50 md:text-xl">{cat.name}</h3>
              <p className="mt-1 text-xs text-background-100 md:text-sm">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default CategorySection;